/**
 * Fetches survey metadata.
 */
export function createSurveyService({ apiClient, apiUrl, interpolateURL, logError, debug }) {
  const useDebug = !!debug?.useDebugMode;
  const fetchWithAwait = (params) => apiClient({ ...params, mode: "resolution" });
  async function getSurvey() {
    const endpoint = "survey/active";
    let survey = {};
    try {
      await fetchWithAwait({
        method: "GET",
        url: interpolateURL({ apiUrl, endpoint, id: null, omitLanguage: false }),
        onSuccess: ({ data }) => {
          if (useDebug) console.log("===== Survey =====", data);
          survey = data ?? {};
        },
        onError: (err) => {
          throw err;
        },
        ignoreError: !useDebug,
        tokenUpdate: false,
        noCompanyHashHeader: true,
      });
      return { ok: true, data: survey, error: null };
    } catch (error) {
      logError("survey/active", error);
      return { ok: false, data: undefined, error };
    }
  }

  return { getSurvey };
}
